import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

const defaultStyles = {
  border: '1px dashed',
  borderColor: 'vpColors.grey',
  padding: '30px 25px',
  gap: '5px',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '10px',
  borderRadius: '5px',
  boxSizing: 'border-box'
};

export const StyledDragnDrop = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'customStyle'
})(({ hovering = false, theme }) =>
  hovering
    ? {
        ...defaultStyles,
        backgroundColor: theme.palette.vpColors.blueLighter,
        borderColor: theme.palette.vpColors.blueMain
      }
    : { ...defaultStyles }
);

export const StyledProgressStack = styled(Stack)(({ theme }) => ({
  padding: '20px',
  width: '100%',
  gap: '8px',
  borderRadius: '5px',
  backgroundColor: theme.palette.vpColors.greyLighter,
  '& .MuiStack-root': {
    flexDirection: 'row',
    gap: '10px',
    adjustContent: 'center'
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpHookFormFileDragAndDrop/styles.js